
import { Component, Vue } from 'vue-property-decorator'
import { ClueService } from '@/services'
import CommentsTable from './components/commentsTable.vue'

@Component({
    components: {
        CommentsTable
    }
})
export default class CommentList extends Vue {
    private pageIndex = 1
    private pageSize = 15
    private pageTotal = 0
    private comments = []
    // private curCommentContent = ''
    private curComment: any = null

    private commentDialog = false
    private userId = ''
    private clueId = ''

    private mounted() {
        this.getComments()
    }

    private async getComments() {
        const params = {
            clue_id: +this.clueId || undefined ,
            user_id: this.userId,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await ClueService.getCommentList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.comments = result.data.list
        }
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.getComments()
    }

/*
    private onLookDetail(content: string) {
        this.commentDialog = true
        this.curCommentContent = content
    }
*/
    private onLookDetail(comment: any) {
        this.commentDialog = true
        this.curComment = comment
    }
    private onSearch() {
        if (isNaN(+this.clueId)) {
            return this.$message({
                type: 'warning',
                message: '请输入正确的线索id',
                showClose: true
            })
        }
        this.getComments()
    }

    private reset() {
        this.clueId = ''
        this.userId = ''
    }
}
